import { render, staticRenderFns } from "./CompletedOrders.vue?vue&type=template&id=88d20b8e&"
import script from "./CompletedOrders.vue?vue&type=script&lang=js&"
export * from "./CompletedOrders.vue?vue&type=script&lang=js&"
import style0 from "./CompletedOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports